<template>
  <div>
    <FilterTable
      :dataTable="getUserWithCompanyName"
      :fieldsToMatch="['email', 'companyName']"
      @filteredMatch="foundedData"
    />
    <!-- USER TABLE -->
    <div>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="founded"
        :single-select="false"
        item-key="badgeNumber.macAddr"
        show-select
        class="elevation-1"
      >
      </v-data-table>
    </div>
  </div>
</template>

<script>
import USERS from '../graphQL/Users.gql';
import HOMES from '../graphQL/Homes.gql';
import FilterTable from './FilterTable.vue';

export default {
  components: {
    FilterTable,
  },
  props: {
    refresh: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      msg: 'Hi there!',
      headers: [
        { text: 'Email', value: 'email' },
        { text: 'Entreprise', value: 'companyName' },
        { text: 'Role', value: 'role', sortable: true },
        {
          text: 'Badge number',
          align: 'start',
          sortable: false,
          value: 'badgeNumber.macAddr',
        },
      ],
      founded: [],
      selected: [],
    };
  },
  computed: {
    getUserWithCompanyName() {
      const userWithCompanyName = [];
      if (this.users && this.homes) {
        this.users.forEach((user) => {
          const company = this.homes[0].companies.filter((c) => c.companyId === user.companyId);
          const userComplete = user;
          userComplete.companyName = company && company[0] ? company[0].name : 'unknown';
          userWithCompanyName.push(userComplete);
        });
      }
      return userWithCompanyName;
    },
  },
  apollo: {
    users: USERS,
    homes: HOMES,
  },
  watch: {
    refresh() {
      this.refreshData();
    },
    getUserWithCompanyName(nVal) {
      this.founded = nVal;
    },
    selected(nVal) {
      const selectedBadges = nVal.map((elm) => elm.badgeNumber);
      this.$emit('selected', selectedBadges);
    },
  },
  methods: {
    refreshData() {
      this.$apollo.queries.users.refetch();
    },
    foundedData(el) {
      this.founded = el;
    },
  },
};
</script>

<style scoped>
.super-class {
  background: #4b79b6;
}
</style>
